import React from 'react'
import { Modal, Button } from 'antd'
import axios from '../../../utils/AxiosUtil'
import { mask, unmask } from '../../../components/reqAndHint'
import { useSelector } from 'react-redux'
import { batch_cols } from '../../../constants/donateListConstants'
export default function BatchReverseModal(props) {
    let { brmVisible, setBrmVisible, detailList, setBillDetailList, actionRef } = props;
    const langValue = useSelector(state => state.langList.value)
    const batchChangeReason = (reason) => {
        let inputs = document.getElementsByClassName('reason_input');
        for (let i = 0; i < inputs.length; i++) {
            let input = inputs[i];
            input.value = reason;
        }

        detailList.forEach((d) => {
            d.reason = reason;
        })
    }

    const batchReverse = async (detailList) => {
        if (detailList.length > 500) {
            Modal.warn({ content: langValue == 0 ? <>单次批量红冲不能超过500条，请分批处理<br />Single batch red flushing cannot exceed 500 pieces, please process in batches</> : (langValue == 1 ? '单次批量红冲不能超过500条，请分批处理' : 'Single batch red flushing cannot exceed 500 pieces, please process in batches') });
            return;
        }
        for (let i = 0; i < detailList.length; i++) {
            let d = detailList[i];
            if (!d.bill_code) {
                Modal.warn({ content: langValue == 0 ? <>序号{i + 1}未填票据号码<br />Number {i + 1}: Bill number not filled in</> : (langValue == 1 ? `序号${i + 1}未填票据号码` : `Number ${i + 1}: Bill number not filled in`) });
                return;
            }
            if (!d.reason) {
                Modal.warn({ content: langValue == 0 ? <>序号{i + 1}未填作废原因<br />Number {i + 1}: Red reason not filled in</> : (langValue == 1 ? `序号${i + 1}未填作废原因` : `Number ${i + 1}: Red reason not filled in`) });
                return;
            }
        };
        mask();
        let { data } = await axios.post('/fund/billmgt/batchReverseBillDetail', { detailList }, { timeout: 120000 });
        unmask();
        if (data && data.ret == 0) {

            let { count, errArr } = data;
            if (!errArr.length) {
                Modal.info({
                    content: langValue == 0 ? <>成功更新{count}条数据<br />Successfully updated {count} pieces of data</> : (langValue == 1 ? `成功更新${count}条数据` : `Successfully updated ${count} pieces of data`),
                    okText: langValue == 0 ? '确定Yes' : (langValue == 1 ? '确定' : 'Yes'),
                    onOk: () => {
                        setBillDetailList();
                        setBrmVisible(false);
                        actionRef.current.reload();
                        actionRef.current.clearSelected();
                    }
                })
            } else {
                let errBillCodes = [];
                Modal.info({
                    content: <>
                        <div>{langValue == 0 ? <>成功更新{count}条数据，失败{errArr.length}条<br />Successfully updated {count} pieces of data, failed {errArr.length} pieces</> : (langValue == 1 ? `成功更新${count}条数据，失败${errArr.length}条` : `Successfully updated ${count} pieces of data, failed ${errArr.length} pieces`)}</div>
                        <div>{langValue == 0 ? '未成功数据Unsuccessful data' : (langValue == 1 ? '未成功数据' : 'Unsuccessful data')}：</div>
                        <table>
                            <tr>
                                <th>{langValue == 0 ? <>序号<br />Serial number</> : (langValue == 1 ? '序号' : 'Serial number')}</th>
                                <th>{langValue == 0 ? <>票据号码<br />Ticket number</> : (langValue == 1 ? '票据号码' : 'Ticket number')}</th>
                                <th>{langValue == 0 ? <>票据名称<br />Ticket name</> : (langValue == 1 ? '票据名称' : 'Ticket name')}</th>
                                <th>{langValue == 0 ? <>金额<br />Amount</> : (langValue == 1 ? '金额' : 'Amount')}</th>
                                <th>{langValue == 0 ? <>备注<br />Remarks</> : (langValue == 1 ? '备注' : 'Remarks')}</th>
                            </tr>
                            {errArr.map((e, i) => {
                                let { seqNo, bill_code, bill_name, amount, msg, en_msg } = e;
                                errBillCodes.push(bill_code);
                                return <tr>
                                    <td>{seqNo}</td>
                                    <td>{bill_code}</td>
                                    <td>{bill_name}</td>
                                    <td>{amount}</td>
                                    <td>{langValue == 0 ? <>{msg}<br />{en_msg}</> : langValue == 1 ? msg : en_msg}</td>
                                </tr>
                            })}
                        </table>

                    </>,
                    okText: langValue == 0 ? '确定Yes' : (langValue == 1 ? '确定' : 'Yes'),
                    onOk: () => {
                        setBillDetailList(detailList.filter(d => errBillCodes.includes(d.bill_code)));
                    }
                })
            }
        }
    }

    return (
        <>
            <Modal
                title={langValue == 0 ? '批量红冲Batch red invoices' : (langValue == 1 ? '批量红冲' : 'Batch red invoices')}
                centered
                visible={brmVisible}
                onCancel={() => {
                    setBillDetailList();
                    setBrmVisible(false);
                }}
                footer={null}
                width={'100%'}
            >
                {detailList && detailList.length ?
                    <>
                        <div style={{ fontSize: '1.3rem', marginBottom: '0.5rem' }}>{langValue == 0 ? '批量修改作废原因(Batch modification of red flush reasons)' : (langValue == 1 ? '批量修改作废原因' : 'Batch modification of red flush reasons')}：<input id='batch_reason' placeholder={langValue == 0 ? '作废原因Reason for red invoices' : (langValue == 1 ? '作废原因' : 'Reason for red invoices')} />
                            <Button type='primary'
                                style={{ fontSize: '1.3rem', height: '2.6rem' }}
                                onClick={() => {
                                    Modal.confirm({
                                        title: langValue == 0 ? '确定修改？Are you sure to make changes?' : (langValue == 1 ? '确定修改？' : 'Are you sure to make changes?'),
                                        content: langValue == 0 ? <>会覆盖所有作废原因<br />It will cover all the reasons for the red flush</> : (langValue == 1 ? '会覆盖所有作废原因' : 'It will cover all the reasons for the red flush'),
                                        okText: langValue == 0 ? '确定Yes' : (langValue == 1 ? '确定' : 'Yes'),
                                        cancelText: langValue == 0 ? '取消Cancle' : (langValue == 1 ? '取消' : 'Cancle'),
                                        onOk: () => {
                                            let reason = document.getElementById('batch_reason').value;
                                            if (!reason) {
                                                Modal.warn({ content: langValue == 0 ? <>原因不能为空<br />Reason cannot be empty</> : (langValue == 1 ? '原因不能为空' : 'Reason cannot be empty') });
                                                return;
                                            }
                                            batchChangeReason(reason);
                                        }
                                    });
                                }}>{langValue == 0 ? '点此修改Click here to modify' : (langValue == 1 ? '点此修改' : 'Click here to modify')}</Button></div>
                        <table className='red_bill_table'>
                            <tbody>
                                <tr><th colSpan={15} className='bill_title'>{langValue == 0 ? '新红冲发票New Red invoice' : (langValue == 1 ? '新红冲发票' : 'New Red invoice')}</th></tr>
                                <tr>
                                    {batch_cols.map(item => {
                                        return (
                                            <th key={item.dataIndex}>{langValue == 0 ? <>{item.ch_title}<br />{item.en_title}</> : (langValue == 1 ? item.ch_title : item.en_title)}</th>
                                        )
                                    })}
                                </tr>
                                {
                                    detailList.map((d, i) => {
                                        return (
                                            <tr>
                                                <td >{i + 1}</td>
                                                <td style={{ color: 'red' }}><input placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')}
                                                    onChange={e => {
                                                        d.bill_code = e.target.value;
                                                    }} /></td>
                                                <td style={{ color: 'red' }}><input className='reason_input' placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')}
                                                    onChange={e => d.reason = e.target.value} /></td>
                                                <td style={{ color: 'red' }}>{d ?.['票据号码']}</td>
                                                <td >{d ?.['开立日']}</td>
                                                <td>{d ?.['票据名称']}</td>
                                                <td style={{ color: 'red' }}>{0 - Number(d ?.['票据金额'])}</td>
                                                <td>{langValue == 0 ? <>{d ?.['捐款项目']}<br />{d ?.en_proj}</> : (langValue == 1 ? d ?.['捐款项目'] : d ?.en_proj)}</td>
                                                <td>{d ?.['地区']}</td>
                                                <td>{d ?.['志工编号']}</td>
                                                <td>{d ?.['志工姓名']}</td>
                                                <td>{d ?.['地址']}</td>
                                                <td>{d ?.['邮箱']}</td>
                                            </tr>
                                        )
                                    })
                                }

                            </tbody>
                        </table>

                        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '10px' }}>
                            <Button
                                // className='submit_btn'
                                style={{ fontSize: '1.3rem', height: '2.6rem' }}
                                type='primary'
                                onClick={() => batchReverse(detailList)}
                            >
                                {langValue == 0 ? '提交Submit' : (langValue == 1 ? '提交' : 'Submit')}
                            </Button>
                        </div>
                    </> : <div>{langValue == 0 ? '请先选择红冲记录Please select the red flush record first' : (langValue == 1 ? '请先选择红冲记录' : 'Please select the red flush record first')}</div>}
            </Modal>
        </>
    )
}
